import React from 'react';
import './WeddingMain.css';

// 봉인식 청첩장 관리자 페이지 (dasol-wooyong-wedding.com/admin)
// TODO: 업로드 사진/영상 조회·다운로드, 방명록 관리, 이벤트 수상자 선별 등
export default function WeddingAdmin() {
  return (
    <div className="wd-root">
      <div className="wd-container">
        <section
          className="wd-section"
          style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
        >
          <h2 className="wd-title">관리자</h2>
          <p className="wd-greeting">관리자 페이지 준비 중입니다.</p>
        </section>
      </div>
    </div>
  );
}
